import { ValidationUtil } from './ValidationUtil';

export class InstallAppUtil {

  constructor(private validUtil:ValidationUtil) {

  }

  public readToken(query:any):{error?:string; payload?:object} {
    
    if(!query['token'])
      return {error:`no token specified`}

    let decodedStr:string;
    let jsonDecodedObj:object;

    try {
      decodedStr = window.atob(query['token']);
    } catch(err) {
      return {error:`Unable to base64 decode token: ${err}`}
    }

    try {
      jsonDecodedObj = JSON.parse(decodedStr);
    } catch(err) {
      return {error:`Unable to JSON decode '${decodedStr}': ${err}`}
    }

    if(Object.keys(jsonDecodedObj).length === 0)
      return {error:`Empty object passed`}

    // we have a search query
    const tokenSchema = this.validUtil.validCustomMeta.required();

    const { error } = this.validUtil.validCustomMeta.validate(jsonDecodedObj);

    if(error)
      return {error:`validation error for ${JSON.stringify(jsonDecodedObj)} => ${error.message}`}

    return {payload: jsonDecodedObj};
  }

  
}